// extracted by mini-css-extract-plugin
module.exports = {"container":"Text_container__3pEng","toolbar":"Text_toolbar__1maTH","toolbarButton":"Text_toolbarButton__3S-4V","editor":"Text_editor__1fkVP","flex1":"Text_flex1__hg8HY"};